<div class="paywall">
  <div class="card">
    <mat-icon class="icon" fontIcon="lock"></mat-icon>
    <h1>{{ title() }}</h1>
    <p>{{ message() }}</p>

    <div class="actions">
      <button mat-stroked-button (click)="logout()">Sair</button>
    </div>
  </div>
</div>
